import { useRef, useEffect } from 'react'
import { FormInstance } from 'antd/es/form/Form'

export const useResetFormOnCloseModal = ({
  form,
  isOpen,
}: {
  form: FormInstance
  isOpen: boolean
}) => {
  const prevOpenRef = useRef<boolean>()
  useEffect(() => {
    prevOpenRef.current = isOpen
  }, [isOpen])
  const prevOpen = prevOpenRef.current

  useEffect(() => {
    if (!isOpen && prevOpen) {
      form.resetFields()
    }
  }, [form, prevOpen, isOpen])
}
